import { Box } from '@mui/material';
import { useInstrumentClassImage, useInstrumentTaxonomyClasses } from '@peritasai/repository';

interface InstrumentThumbnailProps {
  taxonomyClassId: number | null | undefined;
}

export const InstrumentThumbnail = ({ taxonomyClassId }: InstrumentThumbnailProps) => {
  const { data: taxonomyClasses = [] } = useInstrumentTaxonomyClasses();
  const taxonomyClass = taxonomyClassId != null
    ? taxonomyClasses.find((c) => c.id === taxonomyClassId)
    : undefined;
  const imageId = taxonomyClass?.images?.[0]?.id;
  const { data: imageSrc } = useInstrumentClassImage(imageId ?? null);

  return (
    <Box
      data-testid="instrument-thumbnail"
      sx={{
        width: 44,
        height: 44,
        flexShrink: 0,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '4px',
        overflow: 'hidden',
        bgcolor: 'grey.100',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {imageSrc && (
        <Box
          component="img"
          src={imageSrc}
          alt=""
          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      )}
    </Box>
  );
};
